import { useEffect } from 'react';
import { Link, LinkProps, useParams } from 'react-router-dom';
import { Button, Container, Heading } from 'yoso';
import { T } from '~/components/I18n';
import { NoticeDetail } from '~/components/Notice/NoticeDetail';
import { Page } from '~/components/Page';
import { useSearchParams } from '~/components/Route';
import { setCheckedForNoticeItem } from '~/components/Support/Support.helpers';
import './NoticeDetailPage.scss';

export const NoticeDetailPage = () => {
  const { id } = useParams<{ id: string }>();
  const { category = 'all' } = useSearchParams<{ category: string }>();
  useEffect(() => {
    setCheckedForNoticeItem(id);
  }, [id]);

  return (
    <Page className="notice-detail-page" data-event-page_name="Notice_Detail">
      <Container margin="auto">
        <div className="notice-detail-page-header">
          <Heading level={1}>
            <T name="citizen_notice" />
          </Heading>
        </div>
        <div className="notice-detail-page-body">
          <NoticeDetail id={id} />
        </div>
        <div className="notice-detail-page-footer">
          <Button<LinkProps> as={Link} to={`/support/notice?category=${category}`} color="primary">
            <T name="citizen_button_title_to_list" />
          </Button>
        </div>
      </Container>
    </Page>
  );
};
